import { Calculation } from '@servicetitan/financing-api-client';

/**
 * Default copy for the notice shown when a customer's estimate falls within Affirm's configured
 * range and Affirm plans are returned under a different requested provider.
 */
export const AFFIRM_RANGE_NOTICE_TEXT =
    'Based on your desired amount, only Affirm financing is available.';

export const isAffirmProvider = (providerName?: string | null): boolean =>
    providerName?.toLowerCase() === 'affirm';

export const hasAffirmCalculation = (plans: Calculation[]): boolean =>
    plans.some(plan => isAffirmProvider(plan.providerName));

export interface AffirmRangeNoticeInput {
    /** The provider the caller originally requested (from setup data), not the returned plans. */
    requestedProvider?: string | null;
    /** Homeowner vs technician — technicians get the dedicated AffirmPaymentOptionsScreen instead. */
    role?: string | null;
    /** The plans about to be shown to the customer. */
    plans: Calculation[];
}

/**
 * True only when Affirm plans surface under a non-Affirm request in a homeowner flow — i.e. the
 * estimate landed in Affirm's range so the requested provider was swapped out. When Affirm was the
 * requested provider there's nothing to explain. Technicians never reach this PlansList notice:
 * they get AffirmPaymentOptionsScreen, which shows the same copy above the preview calculator.
 */
export const shouldShowAffirmRangeNotice = ({
    requestedProvider,
    role,
    plans,
}: AffirmRangeNoticeInput): boolean =>
    role !== 'technician' && !isAffirmProvider(requestedProvider) && hasAffirmCalculation(plans);
